import React, { useState } from 'react';
import { HiMenuAlt3 } from 'react-icons/hi';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
    if(!nav) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = 'scroll'
    }
  };

  return (
    <div className='absolute flex items-center justify-between w-full p-4'>
      <h1 className='z-20 text-2xl font-bold text-white'>Bhimeshwor Paints.</h1>
      <HiMenuAlt3 onClick={handleNav} className='z-20 text-white cursor-pointer' size={25} />
      <div
        className={
          nav
            ? 'ease-in duration-300 fixed text-gray-300 left-0 top-0 w-full h-screen bg-black/90 px-4 py-7 flex-col z-10'
            : 'absolute top-0 h-screen left-[-100%] ease-in duration-500 z-10'
        }
      >
        <ul className='fixed flex flex-col items-center justify-center w-full h-full'>
          <li className='p-8 text-3xl font-bold'>Home</li>
          <li className='p-8 text-3xl font-bold'>Services</li>
          <li className='p-8 text-3xl font-bold'>Packages</li>
          <li className='p-8 text-3xl font-bold'>About</li>
          <li className='p-8 text-3xl font-bold'>Contacts</li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
